import axios from "axios";

// Base API URL
export const BASE_URL = "https://api.gwayinsure.in";


const API = axios.create({
  baseURL: BASE_URL,
});

// 🔥 Automatically attach token to every request
API.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token").split("").reverse().join("");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;

// ---------------- Customers ----------------

export const getAllCustomers = (ind) =>
  API.get(`/api/customers/all/${ind}`).then(res => res.data);

export const getYourCustomers = (ind) =>
  API.get(`/api/customers/getAllYourCustomer/${ind}`).then(res => res.data);

export const createCustomer = (customer) =>
  API.post("/api/customers", customer).then(res => res.data);

export const updateCustomer = (id, customer) =>
  API.put(`/api/customers/${id}`, customer).then(res => res.data);

export const deleteCustomer = (id) =>
  API.delete(`/api/customers/${id}`).then(res => res.data);

// ---------------- Files ----------------

export const uploadCustomerFile = async (customerId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await API.post(
    `/api/files/upload/${customerId}`,
    formData
  );

  return res.data;
};

export const uploadUserPhoto = async (userId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await API.post(
    `/api/files/upload/user/${userId}`,
    formData
  );

  return res.data;
};

// ---------------- TODO ----------------

export const getTodos = () =>
  API.get("/api/todos").then(res => res.data);

export const createTodo = (title) =>
  API.post("/api/todos", { title }).then(res => res.data);

export const deleteTodo = (id) =>
  API.delete(`/api/todos/${id}`);

export const toggleTodo = (id, completed) =>
  API.put(`/api/todos/${id}`, { completed });

// ---------------- Admin / Users ----------------

export const registerUser = (userData) =>
  API.post("/api/auth/register", userData).then(res => res.data);

export const getAllUsers = () =>
  API.get("/api/auth/users").then(res => res.data);

export const updateUser = (id, userData) =>
  API.put(`/api/auth/users/${id}`, userData).then(res => res.data);

export const deleteUser = (id) =>
  API.delete(`/api/auth/users/${id}`).then(res => res.data);

export const customerEnquiry = (formData) =>
  API.post(`/api/customers/customerEnquiry`, formData).then(res => res.data);

export const validateMobileNo = (mobileNo) =>
  API.post(`/api/customers/validate-mobile?mobileNo=${mobileNo}`).then(res => res.data);

export const getDashboardData = () =>
  API.get("/api/customers/dashboard").then(res => res.data);

export const assignCustomerToUser = (customerIds, userId, userName) =>
  API.post("/api/customers/assignCustomerToUser", { customerIds, userId, userName }).then(res => res.data);
